import {CdkOverlayOrigin} from '@angular/cdk/overlay'
import {UpperCasePipe} from '@angular/common'
import {Component, computed, inject, OnInit} from '@angular/core'
import {MatBadge} from '@angular/material/badge'
import {MatButton, MatFabButton} from '@angular/material/button'
import {MatCard, MatCardContent} from '@angular/material/card'
import {MatDialog} from '@angular/material/dialog'
import {MatIcon} from '@angular/material/icon'
import {Router} from '@angular/router'
import {SIGN_PATH} from '../../general/shared'
import {ProjectService} from '../../services/project.service'
import {UserService} from '../../services/user-service'
import {ProjectButtons} from '../project-buttons/project-buttons'
import {
  NewProjectDialog
} from '../quick-start-dialog/new-project-dialog.component'
import {FirstNamePipe} from '../shared/pipes/first-name/first-name-pipe'
import {Tutorials} from '../tutorials/tutorials'

@Component({
  selector: 'smt-home',
  imports: [
    MatCard,
    MatCardContent,
    MatButton,
    MatIcon,
    MatFabButton,
    MatBadge,
    UpperCasePipe,
    FirstNamePipe,
    ProjectButtons,
    CdkOverlayOrigin,
    Tutorials
  ],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home implements OnInit {

  public readonly projectService = inject(ProjectService)
  public readonly userService = inject(UserService)

  private readonly router = inject(Router)
  private  readonly dialog = inject(MatDialog)

  public latestProjects = computed(() => this.projectService.projects()
    .toSorted((a, b) => a.lastEdit - b.lastEdit)
    .slice(0, 4)
  )

  public newlySharedProjects = computed(() =>
    this.projectService.projects()
      .filter(project => project.newShare))

  public ngOnInit() {
    this.projectService.getProjects().subscribe()
  }

  public quickStart() {
    this.dialog
      .open(NewProjectDialog)
  }

  public selectNewlySharedProject(projectId: string): void {
    this.projectService.projects.update(projects =>
      projects.map(project =>
        project.id === projectId ? { ...project, newShare: false } : project
      )
    )

    this.router.navigate(['/', SIGN_PATH, projectId]).then()
  }
}
